export default {
    fontSize: 20,
    color: '#999999',
    verticalAlign: 'middle'
}
